// import router from '@/app/router';
//
// const goBack = (route) => {
//   router.push({
//     name: 'dashboard',
//     query: route.query
//   });
// };

export default {
  default: {
    component: () => import(/* webpackChunkName: 'certificate/wrNotaryCertificate' */ './WrNotaryCertificate'),
    routes: [
      {
        path: '',
        name: 'wr-notary-certificate',
        component: () => import(/* webpackChunkName: 'certificate/wrNotaryCertificateMain' */ './components/WrNotaryCertificateMain')
      }
    ]
  }
};
